import {Component, Input, OnInit} from '@angular/core';
import {Question} from '../../../data/models/test/question';
import {QuestionCreateDialogComponent} from '../../dialogs/question-create-dialog/question-create-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {QuestionService} from '../../../services/api/question.service';
import {PositionPickerDialogComponent} from '../../dialogs/position-picker-dialog/position-picker-dialog.component';
import {QuestionTypeService} from "../../../services/api/question-type.service";
import {QUESTION_TYPES} from "../../../../constants/questionTypes";

@Component({
  selector: 'app-questions-editor',
  templateUrl: './questions-editor.component.html',
  styleUrls: ['./questions-editor.component.css']
})
export class QuestionsEditorComponent implements OnInit {

  @Input() readonly !: boolean;
  @Input() testId!: number;
  @Input() testType!: string;
  @Input() questions!: Question[];

  buttonsIsHide: boolean; 

  constructor(
    private dialog: MatDialog,
    private questionService: QuestionService,
  ) {
    this.buttonsIsHide = true;
  }

  ngOnInit(): void {
  }

  addQuestion(question: Question): void {
    this.questions.push(question);
  }

  updateQuestion(question: Question): void {
    this.questions = this.questions?.map(q => q.id === question.id ? question : q);
  }

  deleteQuestion(question: Question): void {
    this.questions = this.questions.filter(q => q.id !== question.id);
  }

  onQuestionDrop(event: CdkDragDrop<Question[]>): void {
    if (this.readonly || event.previousIndex === event.currentIndex) {
      return;
    }
    this.questionService.updateQuestion(this.testId, event.item.data.id, {
      position: event.currentIndex + 1,
    }).then(question => {
      this.updateQuestion(question);
      moveItemInArray(this.questions, event.previousIndex, event.currentIndex);
      question.imageFile = event.item.data.imageFile;
    });
  }

  onQuestionDelete(question: Question): void {
    if (this.readonly) {
      return;
    }
    this.deleteQuestion(question);
  }

  openQuestionMoveDialog(question: Question): void {
    if (this.readonly) {
      return;
    }
    const currentPosition = this.questions.findIndex(q => q.id === question.id) + 1;
    const dialogRef = this.dialog.open(PositionPickerDialogComponent, {
      data: {
        min: 1,
        max: this.questions.length,
        current: currentPosition,
      }
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data && data.position !== currentPosition) {
        this.questionService.updateQuestion(this.testId, question.id, {
          position: data.position,
        }).then(updatedQuestion => {
          this.updateQuestion(updatedQuestion);
          moveItemInArray(this.questions, currentPosition - 1, data.position - 1);
          updatedQuestion.imageFile = question.imageFile;
        });
      }
    });
  }

  openQuestionCreateDialog(position: number): void {
    if (this.readonly) {
      return;
    }
    const dialogRef = this.dialog.open(QuestionCreateDialogComponent, {
      minWidth: '50vw',
      data: {
              testId: this.testId,
              position: position,
              testType: this.testType
            },
    });

    dialogRef.afterClosed().subscribe(question => {
      if (question) {
        this.addQuestion(question);
        moveItemInArray(this.questions, this.questions.length, position-1);
      }
    });
  }

  setHideButtons(isHide: boolean): void {
    this.buttonsIsHide = isHide;
  }

}
